import React, { useEffect, useState } from "react";
import { db, auth } from "../../services/firebase";
import { useParams, useNavigate } from 'react-router-dom';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { ReactComponent as EventosIcon } from '../../assets/icons/EventosIcon.svg';
import { ReactComponent as VentasIcon } from '../../assets/icons/VentasIcon.svg';
import LoadingSpinner from '../LoadingSpinner'
import { ReactComponent as StarIcon } from '../../assets/icons/StarIcon.svg'

const EventoDetails = () => {
const { id } = useParams();
const navigate = useNavigate();
const [evento, setEvento] = useState(null);
const [isLoading, setIsLoading] = useState(true);
const [error, setError] = useState(null);
const [postMortemText, setPostMortemText] = useState('');
const [isFinished, setIsFinished] = useState(false);
const [botellasUsadas, setBotellasUsadas] = useState({});
const [agasajados, setAgasajados] = useState({});

const handleAgasajadoToggle = (invitadoId) => {
setAgasajados(prev => ({
...prev,
[invitadoId]: !prev[invitadoId]
}));
};

const handleBotellasChange = (vino, cantidad) => {
setBotellasUsadas(prev => ({
...prev,
[vino]: Number(cantidad) || 0
}));
};

const fetchEvent = async () => {
if (!id) {
setIsLoading(false);
return;
}
setIsLoading(true);
try {
const docRef = doc(db, 'eventos', id);
const docSnap = await getDoc(docRef);

if (docSnap.exists()) {
const eventData = docSnap.data();
setEvento({ id: docSnap.id, ...eventData });
setPostMortemText(eventData.post_mortem || '');
setIsFinished(eventData.finished || false);
setBotellasUsadas(eventData.botellasUsadas || {});
// --- MODIFICACIÓN CLAVE AQUÍ ---
// Inicializa el estado 'agasajados' desde los datos del evento
const agasajadosMap = {};
if (eventData.invitados) {
eventData.invitados.forEach(invitado => {
if (invitado.id && invitado.agasajado) {
agasajadosMap[invitado.id] = true;
}
});
}
setAgasajados(agasajadosMap);
// ------------------------------------

} else {
setError('No se encontró el evento.');
}
} catch (err) {
console.error('Error al obtener el evento:', err);
setError('Error al cargar la información del evento.');
} finally {
setIsLoading(false);
}
};

useEffect(() => {
fetchEvent();
}, [id]);

const handleSavePostMortem = async () => {
try {
const user = auth.currentUser;
if (!user) {
alert('Debes estar logueado para guardar los cambios.');
return;
}
const idToken = await user.getIdToken();

const updateData = {
post_mortem: postMortemText,
finished: true,
botellasUsadas: botellasUsadas,
agasajados: agasajados
};

const response = await fetch(`https://backend-288175208699.europe-west1.run.app/post-mortem/${id}`, {
method: 'PUT',
headers: {
'Content-Type': 'application/json',
'Authorization': `Bearer ${idToken}`,
},
body: JSON.stringify(updateData),
});

const data = await response.json();

if (response.ok) {
alert(data.mensaje);
fetchEvent();
} else {
alert(`Error: ${data.error}`);
}

} catch (err) {
console.error('Error al guardar el post-mortem:', err);
alert('Ocurrió un error al conectar con el servidor.');
}
};

const formatearFecha = (timestamp) => {
if (!timestamp) return 'No disponible';
const date = timestamp.toDate();
return date.toLocaleDateString('es-AR', {
year: 'numeric',
month: 'long',
day: 'numeric',
});
};

const formatearFechasYHora = (fechas, hora) => {
if (!fechas || fechas.length === 0) return '-';
const fechasAgrupadas = fechas.reduce((acc, fechaString) => {
const fecha = new Date(fechaString);
const mes = fecha.toLocaleDateString('es-ES', {
month: 'long'
});
const dia = fecha.getDate();
if (!acc[mes]) {
acc[mes] = [];
}
acc[mes].push(dia);
return acc;
}, {});
const meses = Object.keys(fechasAgrupadas);
let resultado = '';
if (meses.length === 1) {
const dias = fechasAgrupadas[meses[0]];
const diasFormateados = dias.map(d => `${d}`).join(', ').replace(/,([^,]*)$/, ' y$1');
resultado = `${diasFormateados} de ${meses[0]}`;
} else {
const partes = meses.map(mes => {
const dias = fechasAgrupadas[mes];
return `${dias[0]} de ${mes}`;
});
resultado = partes.join(', ').replace(/,([^,]*)$/, ' y$1');
}
const [horas, minutos] = hora.split(':');
let horaFormateada = '';
if (minutos === '00') {
horaFormateada = `${horas} hs.`;
} else {
horaFormateada = `${hora} hs.`;
}
return `${resultado}, ${horaFormateada}`;
};

const formatearPrecio = (precio) => {
const parsedPrecio = parseFloat(precio);
if (isNaN(parsedPrecio)) return 'No disponible';
return parsedPrecio.toLocaleString('es-AR');
};

if (isLoading) {
return <LoadingSpinner />;
}

if (error) {
return <div className="event-details-error">{error}</div>;
}

if (!evento) {
return <div className="event-details-not-found">No se encontró el evento.</div>;
}

const invitados = evento.invitados || [];
// staffNombres ahora es 'staff' para reflejar que es una lista de objetos
const staff = evento.staff || [];


return (
<div style={{ padding: '0 16px', overflow: 'hidden', maxHeight: '100%' }}>
<header className="trazabilidad-header">
<div className="header-content">
<h1>Eventos</h1>
</div>
</header>
<div className="container" style={{ padding: '0 10px' }}>
<div className="formtitle-container">
<div className="formicon-container">
<EventosIcon className="formicon" style={{ height: '20px', margin: 'auto' }} />
</div>
<h1 className="formtitle">Post Mortem</h1>
</div>
<hr className="divider" />
<div className="main-content-grid">
<div className="info-column">
<h1 className="event-title">{evento.titulo}</h1>

<p className="event-description">{evento.descripcion}</p>
<div className="details-subgrid" style={{ overflow: 'hidden', maxHeight: '70%' }}>
<div className="details-item" >
<label style={{ color: '#e65c5c' }}>Fecha DEL EVENTO</label>
<p>{formatearFechasYHora(evento.fechas, evento.hora)}</p>
<label style={{ marginTop: '0px', color: '#e65c5c' }}>COLECCIÓN PRESENTADA</label>
{evento.coleccion.filter(item => item.trim() !== "").map((item, index) => (
<div key={index} style={{ marginBottom: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center', overflow: 'visible' }}>
<li style={{ overflow: 'visible', marginLeft: '17px' }}>
{item}
</li>
<div className="input-group number" style={{ width: '100%' }}>
<input
type="number"
min="0"
className="input"
placeholder="Unidades utilizadas"
value={botellasUsadas[item] || ""}
onChange={(e) => handleBotellasChange(item, e.target.value)}
style={{ width: '100%', cursor: isFinished ? 'default' : 'text' }}
disabled={isFinished}
/><span className="unit">u</span>
</div>
</div>
))}
</div>

<div className="details-item">
<label style={{ color: '#e65c5c' }}>PRECIO POR INVITADO</label>
<p>${formatearPrecio(evento.precio)}</p>
{evento.menu && (
<>
<label style={{ marginTop: '20px', color: '#e65c5c' }} >MENÚ DEL EVENTO</label>
<p style={{ fontSize: '15px' }} className="pre-formatted-text">{evento.menu}</p>
</>
)}
</div>

<div className="details-item">
<div className="personas-list">
<label style={{ paddingBottom: '5px', color: '#e65c5c' }}>Los Invitados</label>
<ul style={{ listStyleType: 'disc' }}>
{invitados.length > 0 ? (
invitados.map((invitado, index) => {
const nombre = invitado.nombre || invitado.razonSocial;
const idUnico = invitado.id || `invitado-${index}`;
const esAgasajado = agasajados[idUnico];
const agasajadoEnDoc = invitado.agasajado || false;
const esUsuario = invitado.tipo === 'usuarios';

return (
<li key={idUnico} style={{ fontSize: '14px' }}>
<div style={{ fontSize: '14px', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
<span style={{
marginRight: '8px',
display: 'inline-block',
maxWidth: '150px',
whiteSpace: 'nowrap',
overflow: 'hidden',
textOverflow: 'ellipsis'
}}>{invitado.nombre && invitado.apellido ? `${invitado.nombre} ${invitado.apellido}` : invitado.razonSocial}</span>
{!isFinished && !esUsuario && evento.precio !== 0 && (
<StarIcon
onClick={() => handleAgasajadoToggle(idUnico)}
className={`star-icon ${esAgasajado ? "favorited" : ""}`}
style={{
cursor: 'pointer',
height: '12px',
transition: 'color 0.2s',
}}
/>
)}
{isFinished && agasajadoEnDoc && (
<StarIcon
style={{
cursor: 'default',
height: '12px',
overflow: 'visible',
fill: '#e65c5c',
stroke: '#e65c5c'
}}
className='star-icon favorited'

/>
)}</div>
</li>
);
})
) : (
<li style={{ fontSize: '14px' }}>No hay invitados.</li>
)}
</ul>
</div>
</div>
<div className="details-item">
<div className="personas-list">
<label style={{ paddingBottom: '5px', color: '#e65c5c' }}>El staff</label>
<ul>
{/* --- INICIO DE MODIFICACIÓN --- */}
{staff.length > 0 ? (
staff.map((miembro, index) => (
<li style={{ fontSize: '14px' }} key={index}>
{miembro.nombre} <span style={{ color: '#888' }}>({miembro.rol})</span>
</li>
))
) : (
<li style={{ fontSize: '14px' }}>No hay staff.</li>
)}
{/* --- FIN DE MODIFICACIÓN --- */}
</ul>
</div>
</div>
</div>
</div>

<div className="post-mortem-column">
<div className="post-mortem-section">
<label>Post Mortem</label>
<div className="post-mortem-textarea-group">
<textarea
className="post-mortem-textarea"
rows="23"
maxLength={825}
placeholder="Escribí acá tus notas y reflexiones sobre el evento..."
value={postMortemText}
onChange={(e) => setPostMortemText(e.target.value)}
disabled={isFinished}
/>
{!isFinished && (<div style={{
textAlign: 'right',
fontSize: '12px',
color: '#888',
marginRight: '5px',
fontFamily: 'Effra'
}}>
{postMortemText.length} / 825
</div>)}</div>

{!isFinished && (
<button className="postmortem-btn" onClick={handleSavePostMortem}>
Guardar
</button>
)}
</div>

</div>
</div>
</div>
</div>
);
};
export default EventoDetails;